import { render, staticRenderFns } from "./ResumeIcon.vue?vue&type=template&id=054d05f0&"
import script from "./ResumeIcon.vue?vue&type=script&lang=js&"
export * from "./ResumeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports